// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cYBp2","contentContainer":"styles_contentContainer__s4jJD","iconContainer":"styles_iconContainer__dHhwm"};